export const ALERT_LOG_GET_SYSTEM_ALERT_LOG = "ALERT_LOG_GET_SYSTEM_ALERT_LOG";
export const ALERT_LOG_GET_SYSTEM_ALERT_LOG_RESPONSE = "ALERT_LOG_GET_SYSTEM_ALERT_LOG_RESPONSE";